"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "PressReleaseComponent", {
  enumerable: true,
  get: function () {
    return _PressReleaseComponent.default;
  }
});
var _PressReleaseComponent = _interopRequireDefault(require("./PressReleaseComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }